// Owner: views-filters-bulk (wave 2); registry conversion by ui-layers. Global merge dialog, opened with
// `openMergeDialog()` (src/features/merge/events) or deep-linked on any page with
// `?merge=<objectKey>:<primaryId>:<secondaryId>`.
import { useRouterState } from '@tanstack/react-router';
import { lazy, useEffect } from 'react';
import { defineGlobalLayer, openLayer } from '../shell/overlays';

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
export const MERGE_DEEP_LINK = new RegExp(`^([a-z][a-z0-9_]*):(${UUID}):(${UUID})$`, 'i');

function MergeDeepLink() {
  const deepLink = useRouterState({ select: (s) => (s.location.search as Record<string, unknown>).merge });
  useEffect(() => {
    const m = typeof deepLink === 'string' ? MERGE_DEEP_LINK.exec(deepLink) : null;
    if (m) openLayer('merge', { objectKey: m[1]!, primaryId: m[2]!, secondaryId: m[3]! });
  }, [deepLink]);
  return null;
}

export default defineGlobalLayer({
  id: 'merge',
  component: lazy(() => import('./merge-records.layer')),
  Effect: MergeDeepLink,
});
